module.exports = __webpack_public_path__ + "img/app.5ea5b5b9.svg";